import { nipClient } from 'application/nip';
import { ICountry } from 'types/dto';
import { isEmpty } from 'lodash';
import { handleCommandResponseData } from 'utils/net';
import qs from 'qs';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IFetchQuery } from 'types/net';

export type IFetchCountriesQuery = IFetchQuery & {
  parentId?: number;
  adminLevel?: number;
};

export async function fetchCountries(query: IFetchCountriesQuery = {}): Promise<ICountry[]> {
  return nipClient
    .get('/countries' + (!isEmpty(query) ? `?${qs.stringify(query)}` : ''))
    .then(handleCommandResponseData<ICountry[]>);
}

export function useCountries(query: IFetchCountriesQuery, options?: UseQueryOptions<ICountry[]>) {
  const queryString: string = qs.stringify(query);
  return useQuery<ICountry[]>(['country', queryString], () => fetchCountries(query), options);
}
